import { render } from "./RequestsView.vue?vue&type=template&id=d1b3a598&scoped=true"
import script from "./RequestsView.vue?vue&type=script&lang=js"
export * from "./RequestsView.vue?vue&type=script&lang=js"

import "./RequestsView.vue?vue&type=style&index=0&id=d1b3a598&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1b3a598"]])

export default __exports__